import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, NotebookPen, Target, Check } from './Icons';

export function ProfilePreview() {
  return (
    <div className="profile-preview" aria-label="能力诊断示意，不是个人测评结果">
      <div className="preview-label">
        <span>
          <Target size={18} /> 读懂你的学习表现
        </span>
        <small>诊断示意</small>
      </div>
      <h3>是题型，还是内容？</h3>
      <p>把两个维度放在一起，找到训练方向。</p>
      <div className="preview-matrix" role="table" aria-label="题型与主题表现示意">
        <div role="row">
          <span role="columnheader">题型 / 主题</span>
          <span role="columnheader">日常生活</span>
          <span role="columnheader">科学</span>
          <span role="columnheader">历史</span>
        </div>
        <div role="row">
          <strong role="rowheader">阅读理解</strong>
          <span role="cell" className="good">
            较好
          </span>
          <span role="cell" className="focus">
            需加强
          </span>
          <span role="cell" className="good">
            较好
          </span>
        </div>
        <div role="row">
          <strong role="rowheader">听力理解</strong>
          <span role="cell" className="good">
            较好
          </span>
          <span role="cell" className="focus">
            需加强
          </span>
          <span role="cell" className="good">
            较好
          </span>
        </div>
      </div>
      <div className="preview-insight">
        <Spark />
        <div>
          <strong>发现值得关注的方向：科学主题</strong>
          <p>跨题型观察内容表现，再安排有针对性的练习。</p>
        </div>
      </div>
      <div className="preview-path">
        <span>识别弱项</span>
        <ArrowRight size={16} />
        <span>专项加强</span>
        <ArrowRight size={16} />
        <span>新题检验</span>
      </div>
    </div>
  );
}
function Spark() {
  return (
    <span className="insight-icon">
      <Target size={23} weight="duotone" />
    </span>
  );
}

const values = [
  {
    icon: BookOpen,
    no: '01',
    title: '题库集中，系统练习',
    text: '青少年版与标准版按考试版本组织，集中查找已开放的题目，少花时间找资料。',
    tag: 'B2 First for Schools · B2 First',
    to: '/practice',
    action: '浏览已开放题库',
  },
  {
    icon: NotebookPen,
    no: '02',
    title: '看懂答案，更读懂原因',
    text: '从句意理解、核心考点到题目分析、易错提醒，交卷后把每一步想明白。',
    tag: '句意 · 考点 · 分析 · 易错点',
    to: '/practice',
    action: '选一组体验解析',
  },
  {
    icon: Target,
    no: '03',
    title: '持续模拟，检验进步',
    text: '专项训练后用模拟测试检验，在不同材料和题目中巩固能力，掌握自己的备考节奏。',
    tag: '专项练习 · 计时模拟 · 学习报告',
    to: '/mock',
    action: '进入模拟训练',
  },
];
export function LearningValue({ compact = false }: { compact?: boolean }) {
  return (
    <section
      className={'learning-values' + (compact ? ' compact' : '')}
      aria-label="冰激凌英语营学习优势"
    >
      {values.map(({ icon: Icon, ...v }) => (
        <article key={v.no}>
          <div className="value-top">
            <Icon size={27} weight="duotone" />
            <span>{v.no}</span>
          </div>
          <h3>{v.title}</h3>
          <p>{v.text}</p>
          <small>
            <Check size={14} />
            {v.tag}
          </small>
          {!compact && (
            <Link to={v.to}>
              {v.action}
              <ArrowRight size={17} />
            </Link>
          )}
        </article>
      ))}
    </section>
  );
}
